import { Box, styled, Typography } from "@material-ui/core";
import {
  EPOCUS_BLUE_BORDER,
  EPOCUS_ICON_ACTIVE,
  EPOCUS_NAVY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../_lib/epocus-palette";

export type WeekPoint = {
  weekStart: string;
  scans: number;
  reviewed: number;
};

const AWAITING_COLOUR = EPOCUS_BLUE_BORDER;

const Bars = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  gap: 12,
  height: 170,
});

const Column = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 6,
  height: "100%",
  justifyContent: "flex-end",
});

const Stack = styled(Box)({
  width: "100%",
  maxWidth: 56,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  flex: 1,
});

const weekLabel = (weekStart: string): string =>
  new Date(weekStart).toLocaleDateString([], {
    day: "numeric",
    month: "short",
    timeZone: "UTC",
  });

export const WeeklyCoverageChart: FC<{ weekly: readonly WeekPoint[] }> = ({
  weekly,
}) => {
  const max = Math.max(1, ...weekly.map(({ scans }) => scans));

  return (
    <Box>
      <Bars>
        {weekly.map(({ weekStart, scans, reviewed }) => {
          const awaiting = Math.max(0, scans - reviewed);
          return (
            <Column key={weekStart}>
              <Typography
                style={{
                  fontSize: rem(12),
                  fontWeight: 700,
                  color: EPOCUS_NAVY,
                }}
              >
                {scans}
              </Typography>
              <Stack>
                <Box
                  aria-hidden
                  style={{
                    height: `${(awaiting / max) * 100}%`,
                    backgroundColor: AWAITING_COLOUR,
                    borderRadius: "4px 4px 0 0",
                  }}
                />
                <Box
                  aria-hidden
                  style={{
                    height: `${(reviewed / max) * 100}%`,
                    backgroundColor: EPOCUS_ICON_ACTIVE,
                  }}
                />
              </Stack>
              <Typography
                style={{ fontSize: rem(11), color: EPOCUS_TEXT_SECONDARY }}
              >
                {weekLabel(weekStart)}
              </Typography>
            </Column>
          );
        })}
      </Bars>

      <Box style={{ display: "flex", gap: 16, marginTop: 12 }}>
        {[
          { label: "QA reviewed", colour: EPOCUS_ICON_ACTIVE },
          { label: "Awaiting", colour: AWAITING_COLOUR },
        ].map(({ label, colour }) => (
          <Box
            key={label}
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <Box
              style={{
                width: 10,
                height: 10,
                borderRadius: 3,
                backgroundColor: colour,
              }}
            />
            <Typography
              style={{ fontSize: rem(12), color: EPOCUS_TEXT_SECONDARY }}
            >
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
